import React, { useEffect } from 'react';
import Header from '../../common/Header/Header';
import Main from '../../landing-page/Main/Main';
import Footer from '../../common/Footer/Footer';
import './Home.css';
import scrollToTop from '../../../functions/scrollToTop';

const Home = () => {
  // Set the document title
  document.title = `Home | InsightCoin`;

  // Scroll to the top of the page when the component mounts
  useEffect(() => {
    scrollToTop();
  }, []);

  // JSX structure for the Home component
  return (
    <>
      {/* Header component */}
      <Header />
      {/* Main component for the main content of the home page */}
      <Main />
      {/* Footer component */}
      <Footer />
    </>
  );
}

export default Home;
